import React, { useState } from 'react';
import './CurriculumMap.css';
import GradeDetail from '../GradeDetail/GradeDetail';

const GRADES = [
  {
    grade: '3', suffix: 'rd', title: 'Basic Electronics',
    tags: ['LED', 'Motor', 'Switch', 'Robot'],
    position: 'top-center',
  },
  {
    grade: '4', suffix: 'th', title: 'Circuits & Sensors',
    tags: ['LDR', 'Transistor', 'Timer', 'Robot'],
    position: 'top-right',
  },
  {
    grade: '5', suffix: 'th', title: 'Arduino & Control',
    tags: ['Arduino', 'Bluetooth', 'Wi-Fi', 'IoT'],
    position: 'middle-right',
  },
  {
    grade: '6', suffix: 'th', title: 'IoT Foundations',
    tags: ['ESP32', 'Smart Alert', 'Weather', 'Automation'],
    position: 'bottom-right',
  },
  {
    grade: '7', suffix: 'th', title: 'Smart Systems',
    tags: ['Security', 'Parking', 'Line Robot', 'Joystick'],
    position: 'bottom-left',
  },
  {
    grade: '8', suffix: 'th', title: 'Advanced IoT',
    tags: ['ThingSpeak', 'Stepper', 'Gas Alert', 'Rain Detect'],
    position: 'middle-left',
  },
  {
    grade: '9', suffix: 'th', title: 'Robotics & Health',
    tags: ['Gesture', 'Bluetooth', 'Health Mon.', 'Alert'],
    position: 'top-left',
  },
];

function CurriculumMap({ programme, onClose }) {
    const [selectedGrade, setSelectedGrade] = useState(null);
  const title = programme === 'short'
    ? '4–5 Month Programme — Grade-wise Curriculum'
    : '8–9 Month Programme — Grade-wise Curriculum';

  const subtitle = programme === 'short'
    ? 'Select a grade below to view the complete project list for the 4–5 month campus programme.'
    : 'Select a grade below to view the complete project list for the 8–9 month campus programme.';

  return (
    <div className="cm__overlay" onClick={onClose}>
      <div className="cm__box" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="cm__header">
          <div>
            <h2 className="cm__title">📚 {title}</h2>
            <p className="cm__subtitle">{subtitle}</p>
          </div>
          <button className="cm__close" onClick={onClose}>✕ Close</button>
        </div>

        {/* Map */}
        <div className="cm__map">

          {/* SVG dashed lines */}
          <svg className="cm__svg" viewBox="0 0 900 620" xmlns="http://www.w3.org/2000/svg">
            {/* Center to Top Center */}
            <line x1="450" y1="310" x2="450" y2="155" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Top Right */}
            <line x1="450" y1="310" x2="700" y2="155" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Middle Right */}
            <line x1="450" y1="310" x2="720" y2="310" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Bottom Right */}
            <line x1="450" y1="310" x2="660" y2="480" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Bottom Left */}
            <line x1="450" y1="310" x2="240" y2="480" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Middle Left */}
            <line x1="450" y1="310" x2="180" y2="310" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
            {/* Center to Top Left */}
            <line x1="450" y1="310" x2="200" y2="155" stroke="#64b5f6" strokeWidth="1.5" strokeDasharray="6,4"/>
          </svg>

          {/* Center Node */}
          <div className="cm__center">
            <div className="cm__center-icon">
              <span className="cm__icon-green">▬</span>
              <span className="cm__icon-pink">▬</span>
            </div>
            <p className="cm__center-title">Curriculum</p>
            <p className="cm__center-sub">Grades 3 – 9</p>
          </div>

          {/* Grade Cards */}
          {GRADES.map((g, i) => (
            <div key={i} className={`cm__card cm__card--${g.position}`}>
              <div className="cm__card-header">
                <span className="cm__grade-num">
                  {g.grade}<sup>{g.suffix}</sup>
                </span>
                <div>
                  <p className="cm__grade-label">GRADE</p>
                  <p className="cm__grade-title">{g.title}</p>
                </div>
              </div>
              <div className="cm__card-tags">
                {g.tags.map((t, j) => (
                  <span key={j} className="cm__tag">{t}</span>
                ))}
              </div>
              <button
  className="cm__card-btn"
  onClick={() => setSelectedGrade(g.grade)}
>
  View →
</button>
            </div>
          ))}

        </div>
        {/* Grade Detail Popup */}
        {selectedGrade && (
          <GradeDetail
            grade={selectedGrade}
            onClose={() => setSelectedGrade(null)}
          />
        )}
      </div>
    </div>
  );
}

export default CurriculumMap;